import styled from 'styled-components';

export const StyledAddChatModal = styled.div`
  width: 100%;

  .holder {
    width: 100%;
    height: 400px;
    overflow-x: auto;
    padding: 20px 10px 0 0;
    margin: 0 0 20px;
    border-width: 1px 0;
    border-style: solid;
    border-color: rgba(157, 157, 157, 0.3);
    .fake-label {
      width: 100%;
    }
  }

  .title {
    display: block;
    font-size: 18px;
    line-height: 22px;
    margin: 0 0 6px;
    color: var(--white);
  }

  .text-holder {
    width: 100%;
    position: relative;
    color: var(--light-gray);
    cursor: pointer;

    .title {
      padding: 0 95px 0 0;
    }

    .description {
      width: 100%;
      font-size: 15px;
      line-height: 20px;

      p {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .date {
      position: absolute;
      top: 0;
      right: 0;
      font-size: 14px;
      line-height: 17px;
      color: var(--light-gray);
    }
  }

  .btn-holder {
    display: flex;
    justify-content: flex-end;
    gap: 16px;
  }
`;
